/** @format */

export class PricelistSchemaHelper {
    public static PRICELIST_SCHEMA_ELEMENT_CONSTANTS = {
        RATE_SCHEMA: 'rateSchema',
        PRICELIST_SCHEMA_ELEMENT_FRACTION: 'pricelistSchemaElementFraction',
        PRICELIST_SCHEMA_ELEMENT_PREFIX: 'pricelistSchemaElementPrefix',
        PRICELIST_SCHEMA_ELEMENT: 'pricelistSchemaElement',
        SCHEMA_CLONE_ID: 'schemaCloneId',
        PRICE_THRESHOLD: 'priceThreshold',
    };

    public static PRICELIST_CLONE_TYPE = {
        PRICELIST_SCHEMA: 'pricelistSchema',
        PRICELIST_SCHEMA_ELEMENT: 'pricelistSchemaElement',
    };
}
